import { render } from "./ScanSigns.vue?vue&type=template&id=d52f576c&ts=true"
import script from "./ScanSigns.vue?vue&type=script&lang=ts"
export * from "./ScanSigns.vue?vue&type=script&lang=ts"

import exportComponent from "/buddy/uup/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__